import { 
  FileText, 
  FolderOpen, 
  
  DollarSign, 
  AlignLeft,
  TrendingUp,
  Heart,
  RefreshCw // 🔥 ICONO PARA CONDICIÓN
} from "lucide-react";

// Array con categorías ordenadas alfabéticamente
const categoriasOrdenadas = [
  "Artigos Infantis",
  "Aventura e Lazer",
  "Brinquedos e Bicicletas",
  "Celulares",
  "Decoração e Lar",
  "Eletro",
  "Esporte e Fitness",
  "Ferramentas, Construção e Reforma",
  "Hobbies, Musica, Arte e Livros",
  "Home Office",
  "Imóveis",
  "Informática e Games",
  "Moda e Achados de Estilo",
  "Moveis",
  "Mundo Pets",
  "Otros",
  "TV, Audio, Video e Drones",
  "Veículos e Autopeças",
];

export default function PostForm({ formData, setFormData, errors }) {
  // Función para formatear el precio en tiempo real
  const formatPrice = (value) => {
    let numericValue = value.replace(/\D/g, "");
    if (numericValue === "") return "";
    let number = parseFloat(numericValue) / 100;
    return number.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "preco") {
      const formattedValue = formatPrice(value);
      setFormData((prev) => ({ ...prev, [name]: formattedValue }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (name === "preco" && value) {
      const cleanValue = value.replace(/[^0-9,]/g, "");
      if (cleanValue && !cleanValue.includes(",")) {
        const number = parseFloat(cleanValue);
        if (!isNaN(number)) {
          const formatted = number.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          setFormData((prev) => ({ ...prev, preco: formatted }));
        }
      }
    }
  };

  return (
    <div className="space-y-5">
      {/* Título */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Título <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <FileText className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            name="titulo"
            value={formData.titulo}
            onChange={handleChange}
            placeholder="Ex: Sofá novo em ótimo estado"
            className={`w-full pl-9 pr-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#449779] focus:border-transparent ${
              errors.titulo ? "border-red-500" : "border-gray-300"
            }`}
          />
        </div>
        {errors.titulo && <p className="text-red-500 text-xs mt-1">{errors.titulo}</p>}
      </div>

      {/* Categoria */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Categoria <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <FolderOpen className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
          <select
            name="categoria"
            value={formData.categoria}
            onChange={handleChange}
            className={`w-full pl-9 pr-3 py-2 border rounded-lg appearance-none bg-white focus:outline-none focus:ring-2 focus:ring-[#449779] focus:border-transparent ${
              errors.categoria ? "border-red-500" : "border-gray-300"
            } ${formData.categoria ? "text-gray-800" : "text-gray-400"}`}
          >
            <option value="">Selecione uma categoria</option>
            {categoriasOrdenadas.map((categoria) => (
              <option key={categoria} value={categoria}>
                {categoria}
              </option>
            ))}
          </select>
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
        {errors.categoria && <p className="text-red-500 text-xs mt-1">{errors.categoria}</p>}
      </div>

      {/* 🔥 CONDICIÓN DEL PRODUCTO - NUEVO CAMPO */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Condição do produto <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <RefreshCw className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
          <select
            name="condicao"
            value={formData.condicao || 'usado'}
            onChange={handleChange}
            className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg appearance-none bg-white focus:outline-none focus:ring-2 focus:ring-[#449779] focus:border-transparent"
          >
            <option value="usado"> Usado</option>
            <option value="novo">Novo</option>
          </select>
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
        <p className="text-xs text-gray-400 mt-1">
          Selecione se o produto é novo ou usado
        </p>
      </div>

      {/* Tipo */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Tipo <span className="text-red-500">*</span>
        </label>
        <div className="flex gap-4">
          <label className={`flex-1 flex items-center justify-center gap-2 p-3 rounded-lg border cursor-pointer transition-all ${
            formData.tipo === "Venda" 
              ? "bg-green-50 border-green-500 text-green-700" 
              : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
          }`}>
            <input
              type="radio"
              name="tipo"
              value="Venda"
              checked={formData.tipo === "Venda"}
              onChange={handleChange}
              className="hidden"
            />
            <TrendingUp className="w-4 h-4" />
            <span className="font-medium">Venda</span>
          </label>
          <label className={`flex-1 flex items-center justify-center gap-2 p-3 rounded-lg border cursor-pointer transition-all ${
            formData.tipo === "Doação" 
              ? "bg-blue-50 border-blue-500 text-blue-700" 
              : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
          }`}>
            <input
              type="radio"
              name="tipo"
              value="Doação"
              checked={formData.tipo === "Doação"}
              onChange={handleChange}
              className="hidden"
            />
            <Heart className="w-4 h-4" />
            <span className="font-medium">Doação</span>
          </label>
        </div>
      </div>

      {/* Precio */}
      {formData.tipo === "Venda" && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Preço <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <DollarSign className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              name="preco"
              value={formData.preco}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="R$ 0,00"
              className={`w-full pl-9 pr-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#449779] focus:border-transparent ${
                errors.preco ? "border-red-500" : "border-gray-300"
              }`}
            />
          </div>
          {errors.preco && <p className="text-red-500 text-xs mt-1">{errors.preco}</p>}
        </div>
      )}

      {/* Descripción */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Descrição <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <AlignLeft className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
          <textarea
            name="descricao"
            value={formData.descricao}
            onChange={handleChange}
            rows={4}
            placeholder="Descreva seu produto com detalhes..."
            className={`w-full pl-9 pr-3 py-2 border rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-[#449779] focus:border-transparent ${
              errors.descricao ? "border-red-500" : "border-gray-300"
            }`}
          />
        </div>
        {errors.descricao && <p className="text-red-500 text-xs mt-1">{errors.descricao}</p>}
      </div>
    </div>
  );
}